(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Sondersteinfinder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ud-stone-filter')) {
    customElements.define('ud-stone-filter', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.version = (this.version || 0) + 1;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.status = this.querySelector('.udsf__status');
        this.results = this.querySelector('.udsf__results');
        this.grid = this.querySelector('.udsf__grid');
        this.more = this.querySelector('.udsf__more');
        this.footer = this.querySelector('.udsf__footer');
        this.progress = this.querySelector('.udsf__progress');
        this.disclosure = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.selection = this.querySelector('.udsf__selection');
        this.badge = this.querySelector('.udsf__badge');
        this.submit = this.querySelector('.udsf__submit');
        this.submitLabel = this.querySelector('.udsf__submit-label');
        this.spinner = this.querySelector('.udsf__spinner');
        this.busy = false;
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.disclosure.open = !this.mobile.matches;
        this.onBreakpoint = event => { this.disclosure.open = !event.matches; };
        this.mobile.addEventListener('change', this.onBreakpoint);
        const options = { signal: this.abort.signal };
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          this.applyFilters();
        }, options);
        this.input.addEventListener('input', () => this.cancelPending(), options);
        this.form.addEventListener('change', event => {
          if (event.target.type === 'radio') this.cancelPending();
        }, options);
        this.input.addEventListener('focus', () => {
          this.loadProducts().catch(() => {});
        }, { ...options, once: true });
        this.form.addEventListener('reset', () => {
          this.cancelPending();
          this.results.hidden = true;
          this.showNative(true);
          this.setStatus('');
          this.selection.textContent = 'Farbnummer & Steinform';
          this.badge.hidden = true;
        }, options);
        this.more.addEventListener('click', () => this.appendMore(), options);
        this.hidden = false;
      }

      disconnectedCallback() {
        this.version++;
        this.setBusy(false);
        this.abort?.abort();
        this.mobile?.removeEventListener('change', this.onBreakpoint);
        this.abort = null;
        this.productsPromise = null;
        this.showNative(true);
      }

      cancelPending() {
        this.version++;
        if (this.busy) this.setStatus('');
        this.setBusy(false);
        this.more.disabled = false;
      }

      setBusy(busy) {
        if (this.busy === busy) return;
        this.busy = busy;
        this.submit.disabled = busy;
        this.spinner.hidden = !busy;
        this.submitLabel.textContent = busy ? 'Suche läuft' : 'Suchen';
        this.results.setAttribute('aria-busy', String(busy));
      }

      normalize(value) {
        return String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
      }

      code(product) {
        const title = product.title || '';
        const match = title.match(/Farbnummer\s*:?\s*([A-Z0-9-]+)/i) || title.match(/\bDMC[\s-]*([A-Z0-9]+)/i);
        if (match) return this.normalize(match[1]);
        const tag = (product.tags || []).find(value => /^DMC[-\s]*(\d+|BLANC|ECRU|B5200)$/i.test(value));
        if (tag) return this.normalize(tag).replace(/^DMC/, '');
        const sku = product.variants?.find(variant => variant.sku)?.sku || '';
        return this.normalize(sku.replace(/^(?:DMC|UD)[-\s]*/i, '').replace(/[-_\s](Q|R|SQUARE|ROUND|QUADRATISCH|RUND)$/i, ''));
      }

      shape(variant) {
        const value = (variant.options || []).join(' ').toLowerCase();
        if (/quadratisch|eckig|square/.test(value)) return 'quadratisch';
        if (/rund|round/.test(value)) return 'rund';
        return '';
      }

      async fetchPage(page, lifetime) {
        const url = new URL(this.dataset.collectionUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set(this.pageData.pageParam || 'page', String(page));
        const controller = new AbortController();
        const cancel = () => controller.abort();
        if (lifetime.aborted) throw new DOMException('Abgebrochen', 'AbortError');
        lifetime.addEventListener('abort', cancel, { once: true });
        const timeout = setTimeout(cancel, 20000);
        try {
          const response = await fetch(url.toString(), { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw new Error('HTTP ' + response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = doc.querySelector('[data-udsf-payload]');
          if (!payload) throw new Error('Filterdaten fehlen');
          const data = JSON.parse(payload.textContent);
          if (data.page !== page || !Array.isArray(data.products)) throw new Error('Ungültige Filterseite');
          return data;
        } finally {
          clearTimeout(timeout);
          lifetime.removeEventListener('abort', cancel);
        }
      }

      loadProducts() {
        if (!this.productsPromise) {
          const lifetime = this.abort.signal;
          this.productsPromise = (async () => {
            if (!this.pageData) this.pageData = JSON.parse(this.querySelector('[data-udsf-payload]').textContent);
            const first = this.pageData.page === 1 ? this.pageData : await this.fetchPage(1, lifetime);
            const products = new Map(first.products.map(product => [product.id, product]));
            for (let page = 2; page <= first.pages; page++) {
              const data = page === this.pageData.page ? this.pageData : await this.fetchPage(page, lifetime);
              const before = products.size;
              data.products.forEach(product => products.set(product.id, product));
              if (data.products.length && products.size === before) throw new Error('Doppelte Filterseite');
            }
            if (lifetime.aborted) throw new DOMException('Abgebrochen', 'AbortError');
            const sorted = Array.from(products.values()).map(product => {
              const code = this.code(product);
              return { ...product, code, number: code.replace(/^[A-Z]+(?=\d)/, '') };
            });
            const collator = new Intl.Collator(this.dataset.locale || 'de', { numeric: true });
            sorted.sort((a, b) => collator.compare(a.code, b.code));
            return sorted;
          })().catch(error => {
            if (this.abort?.signal === lifetime) this.productsPromise = null;
            throw error;
          });
        }
        return this.productsPromise;
      }

      showNative(visible) {
        if (!this.nativeGrid) {
          const facet = document.getElementById('facet-main');
          if (!facet) return;
          this.nativeGrid = facet.closest('[id^="shopify-section-"]') || facet;
          this.originalDisplay = this.nativeGrid.style.getPropertyValue('display');
          this.originalPriority = this.nativeGrid.style.getPropertyPriority('display');
        }
        if (visible) {
          if (this.originalDisplay) this.nativeGrid.style.setProperty('display', this.originalDisplay, this.originalPriority);
          else this.nativeGrid.style.removeProperty('display');
        } else {
          this.nativeGrid.style.setProperty('display', 'none', 'important');
        }
      }

      setStatus(message, error = false) {
        this.status.textContent = message;
        this.status.toggleAttribute('data-error', error);
      }

      async applyFilters() {
        const version = ++this.version;
        const query = this.normalize(this.input.value).replace(/^DMC/, '');
        const selectedShape = this.form.querySelector('input[type="radio"]:checked').value;
        if (!query && selectedShape === 'alle') {
          this.results.hidden = true;
          this.setBusy(false);
          this.showNative(true);
          this.setStatus('');
          this.selection.textContent = 'Farbnummer & Steinform';
          this.badge.hidden = true;
          return;
        }
        this.setStatus('Steine werden gesucht …');
        this.setBusy(true);
        try {
          const products = await this.loadProducts();
          if (version !== this.version || !this.isConnected) return;
          const matches = products.filter(product => {
            const codeMatches = !query || product.code === query || (/^\d+$/.test(query) && product.number === query);
            return codeMatches && product.variants.some(variant => selectedShape === 'alle' || this.shape(variant) === selectedShape);
          });
          const first = await this.buildCards(matches, 0, selectedShape, version);
          if (!first || version !== this.version || !this.isConnected) return;
          this.matches = matches;
          this.selectedShape = selectedShape;
          this.shown = first.end;
          this.grid.replaceChildren(first.fragment);
          this.updateProgress();
          this.showNative(false);
          this.results.hidden = false;
          this.setStatus(this.matches.length ? this.matches.length + (this.matches.length === 1 ? ' Farbe gefunden.' : ' Farben gefunden.') : 'Keine passende Farbe gefunden. Prüfe die Farbnummer oder setze den Filter zurück.');
          const shapeLabel = selectedShape === 'alle' ? 'Alle Formen' : selectedShape === 'quadratisch' ? 'Quadratisch' : 'Rund';
          this.selection.textContent = (query || 'Alle Farben') + ' · ' + shapeLabel;
          this.badge.textContent = String(matches.length);
          this.badge.hidden = false;
          if (this.mobile.matches) {
            this.input.blur();
            this.disclosure.open = false;
            this.summary.focus({ preventScroll: true });
          }
        } catch (error) {
          if (version !== this.version || !this.isConnected) return;
          this.results.hidden = true;
          this.showNative(true);
          this.setStatus('Die Farben konnten nicht vollständig geladen werden. Bitte klicke erneut auf „Suchen“.', true);
        } finally {
          if (version === this.version) this.setBusy(false);
        }
      }

      variantUrl(product, variant) {
        const url = new URL(product.url, window.location.origin);
        url.searchParams.set('variant', String(variant.id));
        return url.toString();
      }

      card(product, selectedShape) {
        const variants = product.variants.filter(variant => selectedShape === 'alle' || this.shape(variant) === selectedShape);
        variants.sort((a, b) => (this.shape(a) === 'quadratisch' ? 0 : 1) - (this.shape(b) === 'quadratisch' ? 0 : 1));
        const selected = variants[0];
        const card = document.createElement('article');
        card.className = 'udsf__card';
        const link = document.createElement('a');
        link.className = 'udsf__link';
        link.href = this.variantUrl(product, selected);
        if (selected.image) {
          const image = document.createElement('img');
          image.className = 'udsf__image';
          image.loading = 'lazy';
          image.decoding = 'async';
          image.src = selected.image;
          image.alt = product.title + ' – ' + (this.shape(selected) === 'quadratisch' ? 'Quadratisch' : 'Rund');
          image.width = 640;
          image.height = 640;
          link.append(image);
        }
        const title = document.createElement('h3');
        title.className = 'udsf__title';
        title.textContent = product.title;
        const price = document.createElement('p');
        price.className = 'udsf__price';
        price.append(document.createTextNode(selected.price));
        if (selected.comparePrice) {
          const compare = document.createElement('del');
          compare.textContent = selected.comparePrice;
          price.append(compare);
        }
        link.append(title, price);
        const choices = document.createElement('div');
        choices.className = 'udsf__variants';
        variants.forEach(variant => {
          const choice = document.createElement('a');
          choice.href = this.variantUrl(product, variant);
          const label = this.shape(variant) === 'quadratisch' ? 'Quadratisch' : this.shape(variant) === 'rund' ? 'Rund' : variant.options.join(' / ');
          choice.textContent = label + (variant.available ? ' · auf Lager' : ' · ausverkauft');
          choice.toggleAttribute('data-sold-out', !variant.available);
          choices.append(choice);
        });
        card.append(link, choices);
        return card;
      }

      async buildCards(matches, start, selectedShape, version) {
        const end = Math.min(start + 24, matches.length);
        const fragment = document.createDocumentFragment();
        for (let i = start; i < end; i++) {
          if (version !== this.version || !this.isConnected) return null;
          const card = this.card(matches[i], selectedShape);
          if (i < 4) card.querySelector('img')?.setAttribute('loading', 'eager');
          fragment.append(card);
          if ((i - start + 1) % 6 === 0) await new Promise(resolve => setTimeout(resolve, 0));
        }
        return { fragment, end };
      }

      updateProgress() {
        this.footer.hidden = !this.matches.length;
        this.progress.textContent = this.shown + ' von ' + this.matches.length + ' Farben';
        this.more.hidden = this.shown >= this.matches.length;
      }

      async appendMore() {
        if (this.more.disabled || this.busy) return;
        const version = this.version;
        const first = this.grid.children.length;
        this.more.disabled = true;
        try {
          const batch = await this.buildCards(this.matches, this.shown, this.selectedShape, version);
          if (!batch || version !== this.version || !this.isConnected) return;
          this.grid.append(batch.fragment);
          this.shown = batch.end;
          this.updateProgress();
          this.grid.children[first]?.querySelector('a')?.focus({ preventScroll: true });
        } finally {
          this.more.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
